import { lazy } from 'react';
import { Route } from 'react-router-dom';
import { IRoute } from 'routes';

export const cmsPaths = {
  index: '/cms',
  manager: {
    list: '/cms/manager',
    create: '/cms/manager/create',
    detail: '/cms/manager/:id'
  },
  app: {
    list: '/cms/app',
    create: '/cms/app/create',
    detail: '/cms/app/:id'
  },
  partner: {
    list: '/cms/partner',
    create: '/cms/partner/create',
    detail: '/cms/partner/:id'
  },
  user: {
    list: '/cms/user',
    detail: '/cms/user/:id'
  },
  driver: {
    list: '/cms/driver',
    detail: '/cms/driver/:id'
  },
  recharge: {
    list: '/cms/recharge',
    create: '/cms/recharge/create',
    detail: '/cms/recharge/:id'
  },
  booking: {
    list: '/cms/booking',
    detail: '/cms/booking/:id'
  },
  vehicleType: {
    list: '/cms/vehicle-type',
    detail: '/cms/vehicle-type/:id'
  },
  airport: {
    list: '/cms/airport',
    create: '/cms/airport/create',
    detail: '/cms/airport/:id'
  },
  fixedRoute: {
    list: '/cms/fixed-router',
    create: '/cms/fixed-router/create',
    detail: '/cms/fixed-router/:id'
  },
  fixedRouteCoefficient: {
    list: '/cms/fixed-router-coefficient',
    create: '/cms/fixed-router-coefficient/create',
    detail: '/cms/fixed-router-coefficient/:id'
  },
  pageStatic: {
    detail: '/cms/page-static/:key'
  },
  sysSetting: {
    booking: '/cms/sys-setting/booking',
    common: '/cms/sys-setting/common'
  },
  notifiTask: {
    list: '/cms/notifi-task',
    create: '/cms/notifi-task/create',
    detail: '/cms/notifi-task/:id'
  },
  all: '*'
};

const cmsRoutes: IRoute[] = [
  {
    route: Route,
    path: cmsPaths.index,
    exact: true,
    component: lazy(() => import('pages/cms/home/HomePage'))
  },
  {
    route: Route,
    path: cmsPaths.manager.list,
    exact: true,
    component: lazy(() => import('pages/cms/manager/ListPage'))
  },
  {
    route: Route,
    path: cmsPaths.manager.create,
    component: lazy(() => import('pages/cms/manager/CreatePage'))
  },
  {
    route: Route,
    path: cmsPaths.manager.detail,
    component: lazy(() => import('pages/cms/manager/DetailPage'))
  },
  {
    route: Route,
    path: cmsPaths.user.list,
    exact: true,
    component: lazy(() => import('pages/cms/user/ListPage'))
  },
  {
    route: Route,
    path: cmsPaths.user.detail,
    component: lazy(() => import('pages/cms/user/DetailPage'))
  },
  {
    route: Route,
    path: cmsPaths.driver.list,
    exact: true,
    component: lazy(() => import('pages/cms/driver/ListPage'))
  },
  {
    route: Route,
    path: cmsPaths.driver.detail,
    component: lazy(() => import('pages/cms/driver/DetailPage'))
  },
  {
    route: Route,
    path: cmsPaths.app.list,
    exact: true,
    component: lazy(() => import('pages/cms/app/ListPage'))
  },
  {
    route: Route,
    path: cmsPaths.app.create,
    component: lazy(() => import('pages/cms/app/CreatePage'))
  },
  {
    route: Route,
    path: cmsPaths.app.detail,
    component: lazy(() => import('pages/cms/app/DetailPage'))
  },
  {
    route: Route,
    path: cmsPaths.partner.list,
    exact: true,
    component: lazy(() => import('pages/cms/partner/ListPage'))
  },
  {
    route: Route,
    path: cmsPaths.partner.create,
    component: lazy(() => import('pages/cms/partner/CreatePage'))
  },
  {
    route: Route,
    path: cmsPaths.partner.detail,
    component: lazy(() => import('pages/cms/partner/DetailPage'))
  },
  {
    route: Route,
    path: cmsPaths.recharge.list,
    exact: true,
    component: lazy(() => import('pages/cms/recharge/ListPage'))
  },
  {
    route: Route,
    path: cmsPaths.recharge.create,
    component: lazy(() => import('pages/cms/recharge/CreatePage'))
  },
  {
    route: Route,
    path: cmsPaths.recharge.detail,
    component: lazy(() => import('pages/cms/recharge/DetailPage'))
  },
  {
    route: Route,
    path: cmsPaths.booking.list,
    exact: true,
    component: lazy(() => import('pages/cms/booking/ListPage'))
  },
  {
    route: Route,
    path: cmsPaths.booking.detail,
    component: lazy(() => import('pages/cms/booking/DetailPage'))
  },
  {
    route: Route,
    path: cmsPaths.vehicleType.list,
    exact: true,
    component: lazy(() => import('pages/cms/vehicle-type/ListPage'))
  },
  {
    route: Route,
    path: cmsPaths.vehicleType.detail,
    component: lazy(() => import('pages/cms/vehicle-type/DetailPage'))
  },
  {
    route: Route,
    path: cmsPaths.fixedRoute.list,
    exact: true,
    component: lazy(() => import('pages/cms/fixed-route/ListPage'))
  },
  {
    route: Route,
    path: cmsPaths.fixedRoute.create,
    component: lazy(() => import('pages/cms/fixed-route/CreatePage'))
  },
  {
    route: Route,
    path: cmsPaths.fixedRoute.detail,
    component: lazy(() => import('pages/cms/fixed-route/DetailPage'))
  },
  {
    route: Route,
    path: cmsPaths.airport.list,
    exact: true,
    component: lazy(() => import('pages/cms/airport/ListPage'))
  },
  {
    route: Route,
    path: cmsPaths.airport.create,
    component: lazy(() => import('pages/cms/airport/CreatePage'))
  },
  {
    route: Route,
    path: cmsPaths.airport.detail,
    component: lazy(() => import('pages/cms/airport/DetailPage'))
  },
  {
    route: Route,
    path: cmsPaths.fixedRouteCoefficient.list,
    exact: true,
    component: lazy(() => import('pages/cms/fixed-route-coefficient/ListPage'))
  },
  {
    route: Route,
    path: cmsPaths.fixedRouteCoefficient.create,
    component: lazy(() => import('pages/cms/fixed-route-coefficient/CreatePage'))
  },
  {
    route: Route,
    path: cmsPaths.fixedRouteCoefficient.detail,
    component: lazy(() => import('pages/cms/fixed-route-coefficient/DetailPage'))
  },
  {
    route: Route,
    path: cmsPaths.notifiTask.list,
    exact: true,
    component: lazy(() => import('pages/cms/notifi-task/ListPage'))
  },
  {
    route: Route,
    path: cmsPaths.notifiTask.create,
    component: lazy(() => import('pages/cms/notifi-task/CreatePage'))
  },
  {
    route: Route,
    path: cmsPaths.pageStatic.detail,
    component: lazy(() => import('pages/cms/page-static/DetailPage'))
  },
  {
    route: Route,
    path: cmsPaths.sysSetting.booking,
    component: lazy(() => import('pages/cms/sys-setting/BookingSysSettingPage'))
  },
  {
    route: Route,
    path: cmsPaths.sysSetting.common,
    component: lazy(() => import('pages/cms/sys-setting/CommonSysSettingPage'))
  },
  {
    route: Route,
    path: cmsPaths.all,
    component: lazy(() => import('pages/common/NotFoundPage'))
  }
];

export default cmsRoutes;
